import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function ProductGifts(props, childrenComponents = []) {
	return {
		componentName: 'ProductGifts',
		componentId: uuidv4(),
		draggableType: 'Container',
		droppableType: 'NONE',
		props: _.merge(
			{
				maxVisibleItems: 'showAll',
			},
			props,
		),
		childrenComponents,
	};
}
